import { useGet } from "@albertine/api-client";
import { mapApiMemberToMemberData } from "../../utils/member.adapter";
import { MemberId } from "../validate";
import { listAllMembersQueryKey } from "./useMembers";

export const getMemberQueryKey = ["getMember"] as const;

export const invalidateMember = {
    meta: { invalidates: [getMemberQueryKey] },
};

export const invalidateMemberAndListAllMembers = {
    meta: { invalidates: [getMemberQueryKey, listAllMembersQueryKey] },
};

export function useMember(memberId: MemberId | undefined) {
    return useGet(
        getMemberQueryKey[0],
        { param: { memberId: memberId ?? "" } },
        {
            enabled: !!memberId && MemberId.safeParse(memberId).success,
            select: mapApiMemberToMemberData,
        },
    );
}
